
import { Card, Col, Container, Input, InputGroup, Modal, ModalBody, ModalHeader, Nav, Row, UncontrolledTooltip } from "reactstrap";
import { Button, CardBody } from 'reactstrap';
import { useEffect, useState, useCallback, forwardRef, InputHTMLAttributes, useMemo } from 'react';
import webservice from '../../../Service/webservice';
import { AesDecrypt, AesEncrypt, keyPromise } from "../../../Service/crypto";
import { ChevronLeft, ChevronRight, Edit, Eye, Trash2 } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import DataTable from "react-data-table-component";
import moment from "moment-timezone";
import { getData, Get_permission } from "./store";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../ReaduxToolkit/Hooks";
import websocket_webservice from '../../../Service/websocket_webservice'
import api from '../../../api';
import ColumnChooser, { ColumnOption, isColVisible } from "../../../Components/ColumnChooser/ColumnChooser";
import { useColumnPreferences } from "../../../hooks/useColumnPreferences";

const CustomHeader = ({ menuActions, handleFilter, value, handlePerPage, rowsPerPage, columnOptions, savedColumns, onColumnsChange }: any) => {
  return (
    <div className='client-master-list-table-header w-100 py-2'>
      <Row>
        <Col lg='6' className='d-flex align-items-center px-0 px-lg-1'>
          <div className='d-flex align-items-center me-4 '>
            <label htmlFor='rows-per-page' className='me-2'>Rows per Page:</label>
            <Input
              type='select'
              id='rows-per-page'
              value={rowsPerPage}
              onChange={handlePerPage}
              className='form-control ms-50 larger-select '
            >
              <option value='10'>10</option>
              <option value='25'>25</option>
              <option value='50'>50</option>
            </Input>
          </div>
          {menuActions.includes('add') && (
            <Button tag={Link} to='/clientManagement/addClientadmin' color='primary' className='ms-2 zoom-on-hover'>
              + Create Client
            </Button>
          )}
        </Col>
        <Col
          lg='6'
          className='d-flex align-items-center justify-content-lg-end mt-lg-0 mt-1 px-0 px-lg-3'
        >
          <div className="mb-2 me-2">
            <ColumnChooser options={columnOptions} savedColumns={savedColumns} onChange={onColumnsChange} />
          </div>
          <InputGroup className="input-group-search mb-2 zoom-on-hover">
            <Input
              type="text"
              placeholder="🔍 Search...."
              value={value}
              onChange={(e) => handleFilter(e.target.value)}
              className="input-search"
            />
          </InputGroup>
        </Col>
      </Row>
    </div>
  );
};


const Clientadmin = () => {
  interface DeleteRowData {
    ShowClient: boolean;
    id: string;
    CompanyName: string;
    Website: string;
    Country: string;
    RefId: string;
    UserName: string;
  }

  interface JsonData {
    field: string;
    value?: any;
    before?: any;
    after?: any;
  }

  interface AuditData {
    Modified: string;
    Action: string;
    JsonData: JsonData[];
    UserName: string;
  }

  interface Permission {
    MenuLabel: string;
    MenuActions: string[];
  }

  interface Provider {
    firstName: string;
    middleName: string;
    lastName: string;
    providerId: string;
    providertaxId: string;
    name: string;
    Username: string;
    link: string;
    status: string;
  }


  const navigate = useNavigate();


  const [scrollInnerModal, setScrollInnerModal] = useState<boolean>(false);
  const [filteredAuditData, setFilteredAuditData] = useState<any[]>([]);
  const [refid, setRefid] = useState<string | null>(null);
  const Username = localStorage.UserName;
  const action = { fromUser: true };
  const [eventId, setEventId] = useState<DeleteRowData[]>([]);
  const [eventId1, setEventId1] = useState(0);
  const selectedRowsPerPage: { [key: number]: DeleteRowData[] } = useMemo(() => ({}), []);


  // const menuActions = ['add','delete'];
  const dispatch = useAppDispatch()
  const store = useSelector((state: any) => state.ClientAdmin)
  const [value, setValue] = useState<string>('');
  const [UserType, setUserType] = useState<string>(localStorage.UserType);
  const [sort, setSort] = useState<string>('');
  const [sortColumn, setSortColumn] = useState<any>('created_date'); // Example initial sort column
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [menuActions, setMenuActions] = useState<string>('');
  const [loadingCheckbox, setLoadingCheckbox] = useState<string | null>(null);

  useEffect(() => {
    if (localStorage.id !== null) {
      dispatch(Get_permission(localStorage.id)).then((response) => {
        const res1 = response.payload;
        const Action = res1[0].Permission.filter(
          (item: any) => item.MenuKey === "CLIENT_MANAGEMENT"
        );
        setMenuActions(Action[0].MenuActions);
      });
    }
  }, [localStorage.id])

  const [localData, setLocalData] = useState<DeleteRowData[]>(store.data);
  // useEffect(() => {
  //   if (UserType&&UserType === 'MOS'){
  //   dispatch(
  //     getData({
  //       UserType,
  //       q: value,
  //       perPage: rowsPerPage,
  //       page: currentPage,
  //       sort,
  //       sortColumn
  //     })
  //   );}
  // }, [dispatch, store.data.length ,UserType,]);

  // Data fetching function (optional: can be extracted outside if reused)
  const fetchData = async () => {
    try {
      if (UserType === 'MOS' || UserType === 'Vendor') {
        const actionResult = await dispatch(
          getData({
            UserType,
            q: value,
            perPage: rowsPerPage,
            page: currentPage,
            sort,
            sortColumn,
          })
        );
        const payload = actionResult.payload as { data: DeleteRowData[] };
        setLocalData(payload.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // useEffect for data fetching
  useEffect(() => {
    fetchData();
  }, [dispatch, UserType, rowsPerPage, currentPage, sort, sortColumn, value]);

  // useEffect for WebSocket handling
  useEffect(() => {
    if (UserType !== 'MOS') return;

    const wsUrl = `${websocket_webservice}ws/clients/`;
    console.log(`DEBUG: Attempting WebSocket connection to: ${wsUrl}`);
    const socket = new WebSocket(wsUrl);
    
    socket.onopen = () => console.log('DEBUG: WS open /ws/clients');
    socket.onerror = (error) => console.error('DEBUG: WS error /ws/clients', error);
    socket.onclose = (e) => console.warn('DEBUG: WS close /ws/clients', e.code, e.reason);

    socket.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);
        console.log("WebSocket message:", msg);

        const getId = (idObj: any) => {
          if (typeof idObj === 'object' && idObj !== null && '$oid' in idObj) {
            return idObj.$oid;
          }
          return String(idObj);
        };

        const toRow = (d: any): DeleteRowData => ({
          ShowClient: Boolean(d.ShowClient),
          id: getId(d._id),
          CompanyName: d.CompanyName || '',
          Website: d.Website || '',
          Country: d.Country || '',
          RefId: d.RefId || '',
          UserName: d.UserName || '',
        });

        if (msg.operationType === 'insert') {
          if (msg.fullDocument) {
            setLocalData((prev) => [toRow(msg.fullDocument), ...prev]);
          }
        } else if (msg.operationType === 'update' || msg.operationType === 'replace') {
          if (msg.fullDocument) {
            const updated = toRow(msg.fullDocument);
            setLocalData((prev) =>
              prev.map((item) => (String(item.id) === String(updated.id) ? { ...item, ...updated } : item))
            );
          }
        } else if (msg.operationType === 'delete') {
          if (msg.documentKey && msg.documentKey._id) {
            const delId = getId(msg.documentKey._id);
            setLocalData((prev) => prev.filter((item) => String(item.id) !== delId));
          }
        }
      } catch (err) {
        console.error("Error processing WebSocket message:", err);
      }
    };

    return () => {
      if (socket.readyState === WebSocket.OPEN) {
        socket.close();
      }
    };
  }, [UserType, websocket_webservice]);


  const handleReloadTable = () => {
    dispatch(
      getData({
        UserType,
        q: value,
        perPage: rowsPerPage,
        page: currentPage,
        sort,
        sortColumn
      })
    );
  };


  const handleFilter = (val: any) => {
    setValue(val)
    setCurrentPage(1)
    dispatch(
      getData({
        UserType,
        q: val,
        perPage: rowsPerPage,
        page: currentPage,
        sort,
        sortColumn,
      })
    )
  }

  const handlePerPage = (e: any) => {
    setCurrentPage(1)
    dispatch(
      getData({
        UserType,
        q: value,
        perPage: parseInt(e.target.value),
        page: currentPage,
        sort,
        sortColumn,
      })
    )
    setRowsPerPage(parseInt(e.target.value))
  }



  const handlePagination = (page: any) => {
    dispatch(
      getData({
        UserType,
        q: value,
        perPage: rowsPerPage,
        page: page.selected + 1,
        sort,
        sortColumn,
      })
    )
    setCurrentPage(page.selected + 1)
  }


  const dataToRender = () => {
    const filters: any = {
      q: value
    };
    const isFiltered = Object.keys(filters).some(function (k) {
      return filters[k].length > 0;
    });

    if (localData.length > 0) {
      return localData;
    } else if (localData.length === 0 && isFiltered) {
      return [];
    } else {
      return store.allData.slice(0, rowsPerPage);
    }
  };

  const handleSort = (column: any, sortDirection: any) => {
    setSort(sortDirection)
    setSortColumn(column.sortField)
    dispatch(
      getData({
        UserType,
        q: value,
        perPage: rowsPerPage,
        page: currentPage,
        sort: sortDirection,
        sortColumn: column.sortField
      })
    )
  }

  const CustomPagination = () => {
    const count = Number(Math.ceil(store.total / rowsPerPage))

    return (
      <ReactPaginate
        previousLabel={<ChevronLeft size={16} />}
        nextLabel={<ChevronRight size={16} />}
        breakLabel="..."
        pageCount={count || 1}
        onPageChange={handlePagination}
        forcePage={currentPage !== 0 ? currentPage - 1 : 0}
        containerClassName="pagination-container"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakClassName="page-item"
        breakLinkClassName="page-link"
        activeClassName="active"
      />
    )
  }






  const deleteClient = async (ids: any) => {
    const key = await keyPromise
    const EncParams = await AesEncrypt(key, ids);
    await api.fetch('api/ClientManagement/DeleteClient', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    });
  };

  const ViewAuditLog = async (row: any) => {
    const Username = localStorage.UserName;
    const Userid = localStorage.id;
    const RefId = row.RefId;
    const Name = row.CompanyName;
    const key = await keyPromise
    const Data = { Username, RefId, Name, Userid };
    const EncParams = await AesEncrypt(key, Data);
    const response = await api.fetch('api/clientmanagement/ViewAuditLog', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then((response) => response.json());
    return response;
  };

  const DeleteAuditLogdata = async (Data: any) => {
    const key = await keyPromise
    Data.Userid = localStorage.id;
    Data.ParentUserId = localStorage.ParentUserId;
    const EncParams = await AesEncrypt(key, Data);
    const response = await api.fetch('api/ClientManagement/DeleteAdminAuditLog', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then((response) => response.json());
    return response;
  };


  const DeleteRow = async (rows: DeleteRowData[] | DeleteRowData) => {
    const deleteRows = async () => {
      const rowCount = Array.isArray(rows) ? rows.length : 1;
      Swal.fire({
        title: "Insurance Verification Platform",
        text: `Are you sure you want to delete ${rowCount} ${rowCount > 1 ? 'Record' : 'Record'}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger ms-1",
        },
        buttonsStyling: false,
        allowOutsideClick: false
      }).then(async function (result) {
        if (result.isConfirmed) {
          if (Array.isArray(rows)) {
            const ids = rows.map(row => row.id);
            const Data = rows.map(row => ({
              Username,
              RefId: row.RefId,
              Name: row.CompanyName
            }));
            await deleteClient(ids);
            await DeleteAuditLogdata(Data);
            // ✅ Remove deleted rows from localData
            setLocalData(prev => prev.filter(item => !ids.includes(item.id)));
          } else {
            const { id, UserName: Name, RefId } = rows;
            const Data = { Username, RefId, Name };
            await deleteClient([id]);
            await DeleteAuditLogdata([Data]);
            // ✅ Remove the deleted row from localData
            setLocalData(prev => prev.filter(item => item.id !== id));
          }
          fetchData()
          Swal.fire({
            icon: "success",
            title: "Insurance Verification Platform",
            text: "Client have been deleted.",
            customClass: {
              confirmButton: "btn btn-success",
            },
            allowOutsideClick: false
          });
          handleReloadTable();
          setEventId1(0)
          setEventId([])
        }
      });
    };
    deleteRows();
  };


  const getAuditlogdata = async (data: any) => {
    const key = await keyPromise
    const EncParams = await AesEncrypt(key, data);
    const response = await api.fetch('api/ClientManagement/getAuditLogData', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then((response) => response.json());
    const TempData = await AesDecrypt(key, response);

    return TempData;
  };

  useEffect(() => {
    const fetchData = async () => {
      if (refid !== null) {
        const res = await getAuditlogdata(refid);
        setFilteredAuditData(res);
      }
    };
    fetchData();
  }, [refid]);



  interface BootstrapCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
    id: string;
  }
  // Handle individual row checkbox change
  const BootstrapCheckbox = forwardRef<HTMLInputElement, BootstrapCheckboxProps>(
    ({ id, ...props }, ref) => (
      <div style={{ position: 'relative', left: '10px' }}>
        <input type='checkbox' id={id} ref={ref} {...props} />
      </div>
    )
  );

  // Handle individual row checkbox change

  const handleChangecheck = useCallback(
    ({ selectedRows }: any) => {
      const selectedEventIds = [];
      selectedRows.forEach((row: any) => {
        selectedEventIds.push(row.id);
      });
      setEventId(selectedRows)
      setEventId1(selectedEventIds.length)
      if (!action.fromUser)
        return;
      selectedRowsPerPage[currentPage] = selectedRows;
    },
    [currentPage, selectedRowsPerPage, action.fromUser]);

  const handleShowClientChange = async (id: string, showClient: boolean) => {
    setLoadingCheckbox(id);
    try {
      const key = await keyPromise;
      const Data = {
        id,
        showClient,
        Username: localStorage.UserName,
        Userid: localStorage.id
      };
      const EncParams = await AesEncrypt(key, Data);
      const response = await api.fetch('api/ClientManagement/UpdateShowClient', {
        method: 'POST',
        body: JSON.stringify({ EncParams })
      });

      if (response.ok) {
        fetchData()
        Swal.fire({
          icon: "success",
          title: "Insurance Verification Platform",
          text: "Show client status updated successfully.",
          customClass: {
            confirmButton: "btn btn-success",
          },
          allowOutsideClick: false
        });
      } else {
        console.error('Failed to update show client status');
      }

      if (response.ok) {
        fetchData()
        console.log('Show client status updated successfully');
      } else {
        console.error('Failed to update show client status');
      }
    } catch (error) {
      console.error('Error updating show client status:', error);
    } finally {
      setLoadingCheckbox(null);
    }
  };

  const Columns = [

    {
      id: "CompanyName",
      name: "Company Name",
      selector: (row: DeleteRowData) => row.CompanyName,
      sortable: true,
    },
    {
      id: "Website",
      name: "Web site",
      selector: (row: DeleteRowData) => row.Website,
      sortable: true,
    },
    {
      id: "Country",
      name: "Country",
      selector: (row: DeleteRowData) => row.Country,
      sortable: true,
    },
    ...(UserType === 'MOS' ? [{
      id: "ShowClient",
      name: "Show Client",
      cell: (row: DeleteRowData) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {loadingCheckbox === row.id ? (
            <div className="spinner-border spinner-border-sm" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <input
              type="checkbox"
              checked={row.ShowClient}
              style={{ cursor: 'pointer' }}
              disabled={loadingCheckbox !== null}
              onChange={async (e) => {
                const isChecked = e.target.checked;
                await handleShowClientChange(row.id, isChecked);
              }}
            />
          )}
        </div>
      ),
      sortable: false,
    }] : []),
    {
      id: "Action",
      name: "Action",
      cell: (row: DeleteRowData) => (
        <>
          <>
            <Eye size={17}
              id='positionLeft'
              color='#09d5ff'
              onClick={() => {
                setScrollInnerModal(true)
                setRefid(row.RefId)
              }}
              style={{ cursor: 'pointer', marginRight: '10px' }}
            />
            <UncontrolledTooltip placement="top" target='positionLeft' style={{ backgroundColor: "#355876", color: "white" }}>
              Audit log
            </UncontrolledTooltip>
          </>

          {eventId1 <= 1 && (
            menuActions.includes("edit") && (
              <>
                <Edit
                  size={17}
                  id='editIcon'
                  color='#FFA500'
                  onClick={() => {
                    navigate(`/clientManagement/editClientadmin`);
                    localStorage.setItem("ClientEdit", row.RefId);
                    ViewAuditLog(row);
                  }}
                  style={{ cursor: 'pointer', marginRight: '10px' }}
                />
                <UncontrolledTooltip placement="top" target='editIcon' style={{ backgroundColor: "#355876", color: "white" }}>
                  Edit
                </UncontrolledTooltip>
              </>
            )
          )}
          {eventId1 === 0 && (
            menuActions.includes("delete") && (
              <>
                <Trash2 size={17} id='deleteIcon' color='#FF0000' onClick={() => DeleteRow(row)} style={{ cursor: 'pointer' }} />
                <UncontrolledTooltip placement="top" target='deleteIcon' style={{ backgroundColor: "#355876", color: "white" }}>
                  Delete
                </UncontrolledTooltip>
              </>
            )
          )}
        </>
      ),

    },
  ];

  const { savedColumns, saveColumns } = useColumnPreferences('ClientAdminListing');
  const columnOptions: ColumnOption[] = Columns.map((c) => ({ id: c.id, label: c.name, locked: c.id === 'CompanyName' || c.id === 'Action' }));
  const visibleColumns = Columns.filter((c) => isColVisible(columnOptions, savedColumns, c.id));

  const customStyles = {
    rows: {
      style: {
        '&:hover': {
          backgroundColor: '#f0f0f0',

        },
      },
    },
    headCells: {
      style: {
        backgroundColor: '#355876',  // Change background color of headers
        color: 'white',  // Change text color of headers
        fontSize: '16px',  // Adjust font size of headers
      },
    },
  };


  const startIndex = (currentPage - 1) * rowsPerPage + 1;
  const endIndex = Math.min(currentPage * rowsPerPage, store.total);
  const CustomLoadingComponent = () => {
    return (
      <div className="">
        {store.no_Data === 'There is no Record Found' ? (
          <h4>
            <br />
            <p>There are no records to display</p>
          </h4>
        ) : (
          <div className="custom-loader">
            <label className="custom-label">Please wait...</label>
            <div className="custom-loading"></div>
          </div>
        )}
      </div>
    );
  };


  return (
    <>
      {/* <Breadcrumbs mainTitle='Client Management' title='Client Management'/> */}
      <Container fluid>
        <div>
          <Modal style={{ maxWidth: '1500px', maxHeight: '600px' }} isOpen={scrollInnerModal} toggle={() => setScrollInnerModal(!scrollInnerModal)} className='modal-dialog-centered modal-lg'>
            <ModalHeader toggle={() => setScrollInnerModal(!scrollInnerModal)}>Client Management Audit Log</ModalHeader>
            <ModalBody>
              <div style={{ maxHeight: '600px', overflow: 'auto' }}>
                {filteredAuditData.length > 0 ? (
                  <table className="audit-table-fixed" style={{ borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ backgroundColor: '#f2f2f2' }}>
                        <th className="audit-tableHeaderStyle" style={{ width: '12%' }}>Date & Time</th>
                        <th className="audit-tableHeaderStyle" style={{ width: '5%' }}>Action</th>
                        <th className="audit-tableHeaderStyle" style={{ width: '73%' }}>Data Set</th>
                        <th className="audit-tableHeaderStyle" style={{ width: '10%' }}>Changed By</th>
                      </tr>
                    </thead>
                    <tbody style={{ alignItems: 'center' }}>
                      {filteredAuditData &&
                        filteredAuditData
                          .sort((a: AuditData, b: AuditData) => new Date(b.Modified).getTime() - new Date(a.Modified).getTime())
                          .map((item: AuditData, index: number) => (
                            <tr key={index}>
                              <td className="audit-tableDataStyle">
                                {(() => {
                                  const localDate = moment.utc(item.Modified).tz(moment.tz.guess()).format('MM/DD/YYYY hh:mm:ss A');
                                  return localDate;
                                })()}
                              </td>
                              <td className="audit-tableDataStyle">{item.Action}</td>
                              <td className="audit-tableDataStyle">
                                {typeof item.JsonData === 'string' ? (
                                  <span>{item.JsonData}</span>
                                ) :
                                  Array.isArray(item.JsonData) ? (
                                    <table className="audit-nested-table" style={{ borderCollapse: 'collapse' }}>
                                      <thead>
                                        <tr style={{ backgroundColor: '#f2f2f2' }}>
                                          <th className="audit-tableHeaderStyle" style={{ width: '20%' }}>Field</th>
                                          {item.Action === 'EDIT' && (
                                            <>
                                              <th className="audit-tableHeaderStyle" style={{ width: '40%' }}>Before</th>
                                              <th className="audit-tableHeaderStyle" style={{ width: '40%' }}>After</th>
                                            </>
                                          )}
                                          {item.Action === 'ADD' && <th className="audit-tableHeaderStyle" style={{ width: '80%' }}>Value</th>}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {item.JsonData
                                          .sort((a: JsonData, b: JsonData) => a.field.localeCompare(b.field))
                                          .map((dataItem: JsonData, dataIndex: number) => (
                                            <tr key={dataIndex}>
                                              <td className="audit-tableDataStyle">{dataItem.field}</td>
                                              {item.Action === 'EDIT' && (
                                                <>
                                                  <td className="audit-tableDataStyle">
                                                    {/* Specific handlers for complex array fields */}
                                                    {dataItem.field === 'Permission' && Array.isArray(dataItem.before) ? (
                                                      // ... (Permission table code remains the same)
                                                      <table style={{ width: '100%' }}>
                                                        <thead>
                                                          <tr><th className="audit-tableHeaderStyle">Menu</th><th className="audit-tableHeaderStyle">Actions</th></tr>
                                                        </thead>
                                                        <tbody>
                                                          {(dataItem.before as Permission[]).map((p) => (<tr key={p.MenuLabel}><td className="audit-tableDataStyle">{p.MenuLabel}</td><td className="audit-tableDataStyle">{Array.isArray(p.MenuActions) ? p.MenuActions.join(', ') : p.MenuActions}</td></tr>))}
                                                        </tbody>
                                                      </table>
                                                    ) : dataItem.field === 'Group' && Array.isArray(dataItem.before) ? (
                                                      // ... (Group table code remains the same)
                                                      <table style={{ width: '100%' }}><thead><tr><th className="audit-tableHeaderStyle">Provider NPI ID</th></tr></thead><tbody>{(dataItem.before as Provider[]).map((p, i) => (<tr key={i}><td className="audit-tableDataStyle">{p.providerId}</td></tr>))}</tbody></table>
                                                    ) : dataItem.field === 'Providers' && Array.isArray(dataItem.before) ? (
                                                      // ... (Providers table code remains the same)
                                                      <table style={{ width: '100%' }}><thead><tr><th className="audit-tableHeaderStyle">First Name</th><th className="audit-tableHeaderStyle">Middle Name</th><th className="audit-tableHeaderStyle">Last Name</th><th className="audit-tableHeaderStyle">Provider NPI ID</th><th className="audit-tableHeaderStyle">Provider Tax ID</th></tr></thead><tbody>{(dataItem.before as Provider[]).map((p, i) => (<tr key={i}><td className="audit-tableDataStyle">{p.firstName}</td><td className="audit-tableDataStyle">{p.middleName}</td><td className="audit-tableDataStyle">{p.lastName}</td><td className="audit-tableDataStyle">{p.providerId}</td><td className="audit-tableDataStyle">{p.providertaxId}</td></tr>))}</tbody></table>
                                                    ) : dataItem.field === 'Insurance' && Array.isArray(dataItem.before) ? (
                                                      // ... (Insurance table code remains the same)
                                                      <table style={{ width: '100%' }}><thead><tr><th className="audit-tableHeaderStyle">Insurance Name</th><th className="audit-tableHeaderStyle">Username</th><th className="audit-tableHeaderStyle">Link</th><th className="audit-tableHeaderStyle">Password</th></tr></thead><tbody>{(dataItem.before as any[]).map((ins, i) => (<tr key={i}><td className="audit-tableDataStyle">{ins.name}</td><td className="audit-tableDataStyle">{ins.Username}</td><td className="audit-tableDataStyle">{ins.link}</td><td className="audit-tableDataStyle">******</td></tr>))}</tbody></table>
                                                    ) : (
                                                      // *** FIX STARTS HERE: Generic value renderer for 'before' ***
                                                      <div className="audit-cell-truncate" onClick={(e) => e.currentTarget.classList.toggle('expanded')} title={String(dataItem.before || '')}>
                                                      {Array.isArray(dataItem.before)
                                                        ? dataItem.before.join(', ')
                                                        : (typeof dataItem.before === 'object' && dataItem.before !== null)
                                                          ? JSON.stringify(dataItem.before, null, 2)
                                                          : String(dataItem.before || '')}
                                                      </div>
                                                      // *** FIX ENDS HERE ***
                                                    )}
                                                  </td>
                                                  <td className="audit-tableDataStyle">
                                                    {/* Specific handlers for complex array fields */}
                                                    {dataItem.field === 'Permission' && Array.isArray(dataItem.after) ? (
                                                      // ... (Permission table code remains the same)
                                                      <table style={{ width: '100%' }}>
                                                        <thead>
                                                          <tr><th className="audit-tableHeaderStyle">Menu</th><th className="audit-tableHeaderStyle">Actions</th></tr>
                                                        </thead>
                                                        <tbody>
                                                          {(dataItem.after as Permission[]).map((p) => (<tr key={p.MenuLabel}><td className="audit-tableDataStyle">{p.MenuLabel}</td><td className="audit-tableDataStyle">{Array.isArray(p.MenuActions) ? p.MenuActions.join(', ') : p.MenuActions}</td></tr>))}
                                                        </tbody>
                                                      </table>
                                                    ) : dataItem.field === 'Group' && Array.isArray(dataItem.after) ? (
                                                      // ... (Group table code remains the same)
                                                      <table style={{ width: '100%' }}><thead><tr><th className="audit-tableHeaderStyle">Provider NPI ID</th></tr></thead><tbody>{(dataItem.after as Provider[]).map((p, i) => (<tr key={i}><td className="audit-tableDataStyle">{p.providerId}</td></tr>))}</tbody></table>
                                                    ) : dataItem.field === 'Providers' && Array.isArray(dataItem.after) ? (
                                                      // ... (Providers table code remains the same)
                                                      <table style={{ width: '100%' }}><thead><tr><th className="audit-tableHeaderStyle">First Name</th><th className="audit-tableHeaderStyle">Middle Name</th><th className="audit-tableHeaderStyle">Last Name</th><th className="audit-tableHeaderStyle">Provider NPI ID</th><th className="audit-tableHeaderStyle">Provider Tax ID</th></tr></thead><tbody>{(dataItem.after as Provider[]).map((p, i) => (<tr key={i}><td className="audit-tableDataStyle">{p.firstName}</td><td className="audit-tableDataStyle">{p.middleName}</td><td className="audit-tableDataStyle">{p.lastName}</td><td className="audit-tableDataStyle">{p.providerId}</td><td className="audit-tableDataStyle">{p.providertaxId}</td></tr>))}</tbody></table>
                                                    ) : dataItem.field === 'Insurance' && Array.isArray(dataItem.after) ? (
                                                      // ... (Insurance table code remains the same)
                                                      <table style={{ width: '100%' }}><thead><tr><th className="audit-tableHeaderStyle">Insurance Name</th><th className="audit-tableHeaderStyle">Username</th><th className="audit-tableHeaderStyle">Link</th><th className="audit-tableHeaderStyle">Password</th><th className="audit-tableHeaderStyle">Status</th></tr></thead><tbody>{(dataItem.after as any[]).map((ins, i) => (<tr key={i}><td className="audit-tableDataStyle">{ins.name}</td><td className="audit-tableDataStyle">{ins.Username}</td><td className="audit-tableDataStyle">{ins.link}</td><td className="audit-tableDataStyle">******</td><td className="audit-tableDataStyle">{ins.status || ''}</td></tr>))}</tbody></table>
                                                    ) : (
                                                      // *** FIX STARTS HERE: Generic value renderer for 'after' ***
                                                      <div className="audit-cell-truncate" onClick={(e) => e.currentTarget.classList.toggle('expanded')} title={String(dataItem.after || '')}>
                                                      {Array.isArray(dataItem.after)
                                                        ? dataItem.after.join(', ')
                                                        : (typeof dataItem.after === 'object' && dataItem.after !== null)
                                                          ? JSON.stringify(dataItem.after, null, 2)
                                                          : String(dataItem.after || '')}
                                                      </div>
                                                      // *** FIX ENDS HERE ***
                                                    )}
                                                  </td>
                                                </>
                                              )}
                                              {item.Action === 'ADD' && (
                                                <td className="audit-tableDataStyle">
                                                  {dataItem.field === 'Password' || dataItem.field === 'Pin' ? (
                                                    '******'
                                                  ) : dataItem.field === 'Permission' && Array.isArray(dataItem.value) ? (
                                                    // ... (Permission table code remains the same)
                                                    <table style={{ width: '100%' }}><thead><tr><th className="audit-tableHeaderStyle">Menu</th><th className="audit-tableHeaderStyle">Actions</th></tr></thead><tbody>{(dataItem.value as Permission[]).map((p) => (<tr key={p.MenuLabel}><td className="audit-tableDataStyle">{p.MenuLabel}</td><td className="audit-tableDataStyle">{Array.isArray(p.MenuActions) ? p.MenuActions.join(', ') : p.MenuActions}</td></tr>))}</tbody></table>
                                                  ) : dataItem.field === 'Providers' && Array.isArray(dataItem.value) ? (
                                                    // ... (Providers table code remains the same)
                                                    <table style={{ width: '100%' }}><thead><tr><th className="audit-tableHeaderStyle">First Name</th><th className="audit-tableHeaderStyle">Middle Name</th><th className="audit-tableHeaderStyle">Last Name</th><th className="audit-tableHeaderStyle">Provider ID</th><th className="audit-tableHeaderStyle">Provider Tax Id</th></tr></thead><tbody>{(dataItem.value as Provider[]).map((p, i) => (<tr key={i}><td className="audit-tableDataStyle">{p.firstName}</td><td className="audit-tableDataStyle">{p.middleName}</td><td className="audit-tableDataStyle">{p.lastName}</td><td className="audit-tableDataStyle">{p.providerId}</td><td className="audit-tableDataStyle">{p.providertaxId}</td></tr>))}</tbody></table>
                                                  ) : dataItem.field === 'Group' && Array.isArray(dataItem.value) ? (
                                                    // ... (Group table code remains the same)
                                                    <table style={{ width: '100%' }}><thead><tr><th className="audit-tableHeaderStyle">Provider ID</th></tr></thead><tbody>{(dataItem.value as Provider[]).map((p, i) => (<tr key={i}><td className="audit-tableDataStyle">{p.providerId}</td></tr>))}</tbody></table>
                                                  ) : dataItem.field === 'Insurance' && Array.isArray(dataItem.value) ? (
                                                    // ... (Insurance table code remains the same)
                                                    <table style={{ width: '100%' }}><thead><tr><th className="audit-tableHeaderStyle">Insurance Name</th><th className="audit-tableHeaderStyle">Username</th><th className="audit-tableHeaderStyle">Link</th><th className="audit-tableHeaderStyle">Password</th><th className="audit-tableHeaderStyle">Status</th></tr></thead><tbody>{(dataItem.value as any[]).map((ins, i) => (<tr key={i}><td className="audit-tableDataStyle">{ins.name}</td><td className="audit-tableDataStyle">{ins.Username}</td><td className="audit-tableDataStyle">{ins.link}</td><td className="audit-tableDataStyle">******</td><td className="audit-tableDataStyle">{ins.status || ''}</td></tr>))}</tbody></table>
                                                  ) : (
                                                    // *** FIX STARTS HERE: Generic value renderer for 'value' ***
                                                    <div className="audit-cell-truncate" onClick={(e) => e.currentTarget.classList.toggle('expanded')} title={String(dataItem.value || '')}>
                                                    {Array.isArray(dataItem.value)
                                                      ? dataItem.value.join(', ')
                                                      : (typeof dataItem.value === 'object' && dataItem.value !== null)
                                                        ? JSON.stringify(dataItem.value, null, 2)
                                                        : String(dataItem.value || '')}
                                                    </div>
                                                    // *** FIX ENDS HERE ***
                                                  )
                                                  }
                                                </td>
                                              )}
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  ) : (
                                    <pre>{JSON.stringify(item.JsonData, null, 2)}</pre>
                                  )}
                              </td>
                              <td className="audit-tableDataStyle">{item.UserName}</td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                ) : (
                  <div><center>No data available</center></div>
                )}
              </div>
            </ModalBody>
          </Modal>
        </div>
        <Row>
          <Col sm={12}>
            <Card >
              <CardBody>
                <div className="table-responsive">
                  <div className="dataTables_wrapper">
                    <DataTable
                      persistTableHead
                      subHeader={true}
                      responsive={true}
                      onSort={handleSort}
                      data={dataToRender()}
                      columns={visibleColumns}
                      paginationServer
                      customStyles={customStyles}
                      paginationPerPage={rowsPerPage}
                      paginationDefaultPage={currentPage}
                      selectableRows
                      selectableRowsHighlight
                      selectableRowsComponent={BootstrapCheckbox as unknown as React.ReactNode}
                      onSelectedRowsChange={handleChangecheck}
                      paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                      noDataComponent={<CustomLoadingComponent />}
                      paginationComponent={CustomPagination}
                      subHeaderComponent={
                        <CustomHeader
                          value={value}
                          menuActions={menuActions}
                          rowsPerPage={rowsPerPage}
                          handleFilter={handleFilter}
                          handlePerPage={handlePerPage}
                          columnOptions={columnOptions}
                          savedColumns={savedColumns}
                          onColumnsChange={saveColumns}
                        />
                      }
                    />
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ paddingLeft: '2%' }}>
                        {store.total && (
                          <span><strong>{`${startIndex} to ${endIndex} of ${store.total} entries`}</strong></span>
                        )}
                      </div>
                      <div>
                        <CustomPagination />
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
            <div>
              {eventId1 > 0 && menuActions.includes('delete') && (
                <div className="customizer-links open">
                  <Nav className=" flex-column nav-pills">
                    <a className="nav-link" onClick={() => DeleteRow(eventId)}>
                      <span>Delete</span>
                      <Trash2 className="trash-icon" size={20} />
                    </a>
                  </Nav>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Clientadmin;
